import Icon from '../components/Icon.vue'

Icon.register({"ellipsis-v":{"width":384,"height":1792,"paths":[{"d":"M384 1248v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zM384 736v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zM384 224v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ellipsis-v.js
// module id = 504
// module chunks = 0